import React, { useMemo } from "react";
import logo from "../../assets/img/logo-icon.jpg";
import "../../styles.css";

// Barra superior de /login (igual que Terraza en modo prelogin): solo logo
// a la izquierda y controles de ventana de Electron a la derecha.
export default function LoginHeader() {
  const isElectron = useMemo(() => typeof window !== "undefined" && !!window.electronAPI, []);

  return (
    <header className="eh-root">
      <div className="eh-bar eh-bar--compact">
        <div className="eh-left">
          <div className="eh-brand">
            <img className="eh-logo" style={{ height: 30, width: "auto" }} src={logo} alt="Visum Oftalmología" />
          </div>
        </div>

        <div className="eh-right electron-no-drag">
          {isElectron && (
            <div className="eh-win">
              <button className="eh-win-btn" title="Minimizar" onClick={() => window.electronAPI?.minimize?.()}>🗕</button>
              <button className="eh-win-btn" title="Maximizar/Restaurar" onClick={() => window.electronAPI?.maximize?.()}>🗖</button>
              <button className="eh-win-btn close" title="Cerrar" onClick={() => window.electronAPI?.close?.()}>✕</button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
